import TermsAndDPA from './TermsAndDPA'

export default TermsAndDPA
